/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDomainList() {
        return HttpService.get(environment.API_MY_COMPANY + '/domain-role');
    },
    // API_COOKIE_MANAGEMENT
    getHeaderDetail(domainId) {
        return HttpService.get(
            environment.API_COOKIE_MANAGEMENT + `/${domainId}/header`
        );
    },
    publicCookieBanner(domainId, payload) {
        return HttpService.post(
            environment.API_COOKIE_MANAGEMENT + `/${domainId}/publish`,
            payload
        );
    },

    getBannerPosition() {
        return HttpService.get(
            environment.API_COOKIE_MANAGEMENT + `/m/banner/position`
        );
    },

    getCustomizeBanner(domainId) {
        return HttpService.get(
            environment.API_COOKIE_MANAGEMENT + `/banner/${domainId}`
        );
    },
    updateCustomizeBanner(domainId, payload) {
        return HttpService.put(
            environment.API_COOKIE_MANAGEMENT + `/banner/${domainId}`,
            payload
        );
    },

    // API_SETTING_PREFERENCE
    getSettingPeference(domainId) {
        return HttpService.get(
            environment.API_SETTING_PREFERENCE + `/cookie-category/${domainId}`
        );
    },
    getCustomizeSettingPeference(domainId) {
        return HttpService.get(
            environment.API_SETTING_PREFERENCE + `/${domainId}`
        );
    },
    updateCustomizeSettingPeference(payload) {
        return HttpService.put(environment.API_SETTING_PREFERENCE, payload);
    },

    //Dashboard
    getCompany() {
        return HttpService.get(environment.API_WFSECURE + `/company`);
    },

    // domainlist
    //Domain
    getDomainListByCompany(params) {
        return HttpService.get(environment.API_MY_COMPANY + '/domain', {
            params,
        });
    },
    getAcceptance(params) {
        return HttpService.get(
            environment.API_WFSECURE + '/cookie/acceptance',
            {
                params,
            }
        );
    },
    getCookieCategory(params) {
        return HttpService.get(environment.API_WFSECURE + `/cookie/category`, {
            params,
        });
    },
    getAction() {
        return HttpService.get(environment.API_WFSECURE + `/m/cookie/action`);
    },
    getCategory(params) {
        return HttpService.get(
            environment.API_WFSECURE +
                `/cookie-dashboard/cookie-category/dropdown`,
            {
                params,
            }
        );
    },
    getCookieConsentGraph(params) {
        return HttpService.get(
            environment.API_COOKIE_MANAGEMENT + `/graph-chart`,
            {
                params,
            }
        );
    },
    getCookieConsentLog(params) {
        return HttpService.get(environment.API_COOKIE_MANAGEMENT + `/search`, {
            params,
        });
    },
    getExport(params) {
        return HttpService.get(environment.API_COOKIE_MANAGEMENT + `/export`, {
            params,
        });
    },
};
